export { default as Img200 } from './processed/200/Darkest-Minds-The.jpg';
export { default as Img400 } from './processed/400/Darkest-Minds-The.jpg';
export { default as Imgthumb } from './processed/thumb/Darkest-Minds-The.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Darkest-Minds-The.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Darkest-Minds-The.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      213,
      96,
      30
    ],
    "_population": 2324,
    "_hsl": [
      0.06010928961748633,
      0.7530864197530864,
      0.47647058823529415
    ]
  },
  "LightVibrant": {
    "_rgb": [
      235,
      168,
      128
    ],
    "_population": 2608,
    "_hsl": [
      0.06230529595015577,
      0.7278911564625847,
      0.7117647058823529
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      171,
      43,
      7
    ],
    "_population": 2282,
    "_hsl": [
      0.03658536585365854,
      0.9213483146067415,
      0.34901960784313724
    ]
  },
  "Muted": {
    "_rgb": [
      150,
      116,
      104
    ],
    "_population": 650,
    "_hsl": [
      0.04347826086956521,
      0.18110236220472442,
      0.4980392156862745
    ]
  },
  "LightMuted": {
    "_rgb": [
      182,
      213,
      213
    ],
    "_population": 108,
    "_hsl": [
      0.5,
      0.26956521739130446,
      0.7745098039215687
    ]
  },
  "DarkMuted": {
    "_rgb": [
      106,
      81,
      50
    ],
    "_population": 528,
    "_hsl": [
      0.09226190476190475,
      0.358974358974359,
      0.3058823529411765
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Darkest-Minds-The.js